import { useEffect, useState } from "react";
import { API } from "../../network/API";
export const useValidatedDocuments = (fileNames) => {
    const [validatedDocuments, setValidatedDocuments] = useState([]);
    useEffect(() => {
        let isMounted = true;
        API.get(`${process.env.REACT_APP_LYSA_DOCS_URL}/docs.json`, false, {
            credentials: undefined,
            headers: {},
        })
            .then((docsAvailable) => {
            const validatedDocuments = docsAvailable.filter((docAvailable) => fileNames.some((fileName) => docAvailable.fileName === fileName));
            if (fileNames.length !== validatedDocuments.length) {
                const missingDocuments = fileNames.filter((doc) => !validatedDocuments.some((foundDoc) => foundDoc.fileName === doc));
                throw new Error(`Missing documents: ${missingDocuments.join(", ")}`);
            }
            if (!isMounted) {
                return;
            }
            setValidatedDocuments(validatedDocuments);
        })
            .catch((error) => {
            console.error(error);
        });
        return () => {
            isMounted = false;
        };
    }, [fileNames]);
    return validatedDocuments;
};
